import "../assets/styles/App.css";
import React, { useState, useEffect, useRef } from "react";
import QRCode from "react-qr-code";
import ProfileSelect from "../components/ProfileSelect";
import axios from "axios";
import "../assets/styles/YGwebticket.css";
import ygLogo from "../assets/images/yg-logo.png";

// import useSearchParams
import { useSearchParams } from "react-router-dom";

async function downScaleImage(img, size, s1, s2) {
  return new Promise((resolve, reject) => {
    // https://stackoverflow.com/a/19144434
    // image, wanted size, x, y, width, height(window)
    var imgCV = document.createElement("canvas");

    let s3,
      s4 = 0;
    loadImageProcess(img).then((img) => {
      s3 = img.width;
      s4 = img.height;

      imgCV.width = s3;
      imgCV.height = s4;

      var imgCtx = imgCV.getContext("2d");
      imgCtx.drawImage(img, s1, s2, s3, s4, 0, 0, s3, s4);
      const scale = s3 > s4 ? size / s3 : size / s4;

      if (scale >= 1) {
        console.log(imgCV);
        resolve(imgCV);
      } else {
        downScaleCanvas(imgCV, scale, resolve);
      }
    });
  });
}

function loadImageProcess(src) {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}
async function downScaleCanvas(cv, scale, resolve) {
  // scales the canvas by (float) scale < 1
  // returns a new canvas containing the scaled image.
  if (!(scale < 1) || !(scale > 0)) throw "scale must be a positive number <1 ";
  scale = normaliseScale(scale);
  var sqScale = scale * scale; // square scale =  area of a source pixel within target
  var sw = cv.width; // source image width
  var sh = cv.height; // source image height
  var tw = Math.floor(sw * scale); // target image width
  var th = Math.floor(sh * scale); // target image height
  var sx = 0,
    sy = 0,
    sIndex = 0; // source x,y, index within source array
  var tx = 0,
    ty = 0,
    yIndex = 0,
    tIndex = 0; // target x,y, x,y index within target array
  var tX = 0,
    tY = 0; // rounded tx, ty
  var w = 0,
    nw = 0,
    wx = 0,
    nwx = 0,
    wy = 0,
    nwy = 0; // weight / next weight x / y
  // weight is weight of current source point within target.
  // next weight is weight of current source point within next target's point.
  var crossX = false; // does scaled px cross its current px right border ?
  var crossY = false; // does scaled px cross its current px bottom border ?
  var sBuffer = cv.getContext("2d").getImageData(0, 0, sw, sh).data; // source buffer 8 bit rgba
  var tBuffer = new Float32Array(3 * tw * th); // target buffer Float32 rgb
  var sR = 0,
    sG = 0,
    sB = 0; // source's current point r,g,b
  for (sy = 0; sy < sh; sy++) {
    ty = sy * scale; // y src position within target
    tY = 0 | ty; // rounded : target pixel's y
    yIndex = 3 * tY * tw; // line index within target array
    crossY = tY !== (0 | (ty + scale));
    if (crossY) {
      // if pixel is crossing botton target pixel
      wy = tY + 1 - ty; // weight of point within target pixel
      nwy = ty + scale - tY - 1; // ... within y+1 target pixel
    }
    for (sx = 0; sx < sw; sx++, sIndex += 4) {
      tx = sx * scale; // x src position within target
      tX = 0 | tx; // rounded : target pixel's x
      tIndex = yIndex + tX * 3; // target pixel index within target array
      crossX = tX !== (0 | (tx + scale));
      if (crossX) {
        // if pixel is crossing target pixel's right
        wx = tX + 1 - tx; // weight of point within target pixel
        nwx = tx + scale - tX - 1; // ... within x+1 target pixel
      }
      sR = sBuffer[sIndex]; // retrieving r,g,b for curr src px.
      sG = sBuffer[sIndex + 1];
      sB = sBuffer[sIndex + 2];
      if (!crossX && !crossY) {
        // pixel does not cross
        // just add components weighted by squared scale.
        tBuffer[tIndex] += sR * sqScale;
        tBuffer[tIndex + 1] += sG * sqScale;
        tBuffer[tIndex + 2] += sB * sqScale;
      } else if (crossX && !crossY) {
        // cross on X only
        w = wx * scale;
        // add weighted component for current px
        tBuffer[tIndex] += sR * w;
        tBuffer[tIndex + 1] += sG * w;
        tBuffer[tIndex + 2] += sB * w;
        // add weighted component for next (tX+1) px
        nw = nwx * scale;
        tBuffer[tIndex + 3] += sR * nw;
        tBuffer[tIndex + 4] += sG * nw;
        tBuffer[tIndex + 5] += sB * nw;
      } else if (!crossX && crossY) {
        // cross on Y only
        w = wy * scale;
        // add weighted component for current px
        tBuffer[tIndex] += sR * w;
        tBuffer[tIndex + 1] += sG * w;
        tBuffer[tIndex + 2] += sB * w;
        // add weighted component for next (tY+1) px
        nw = nwy * scale;
        tBuffer[tIndex + 3 * tw] += sR * nw;
        tBuffer[tIndex + 3 * tw + 1] += sG * nw;
        tBuffer[tIndex + 3 * tw + 2] += sB * nw;
      } else {
        // crosses both x and y : four target points involved
        // add weighted component for current px
        w = wx * wy;
        tBuffer[tIndex] += sR * w;
        tBuffer[tIndex + 1] += sG * w;
        tBuffer[tIndex + 2] += sB * w;
        // for tX + 1; tY px
        nw = nwx * wy;
        tBuffer[tIndex + 3] += sR * nw;
        tBuffer[tIndex + 4] += sG * nw;
        tBuffer[tIndex + 5] += sB * nw;
        // for tX ; tY + 1 px
        nw = wx * nwy;
        tBuffer[tIndex + 3 * tw] += sR * nw;
        tBuffer[tIndex + 3 * tw + 1] += sG * nw;
        tBuffer[tIndex + 3 * tw + 2] += sB * nw;
        // for tX + 1 ; tY +1 px
        nw = nwx * nwy;
        tBuffer[tIndex + 3 * tw + 3] += sR * nw;
        tBuffer[tIndex + 3 * tw + 4] += sG * nw;
        tBuffer[tIndex + 3 * tw + 5] += sB * nw;
      }
    } // end for sx
  } // end for sy
  // create result canvas
  var resCV = document.createElement("canvas");
  resCV.width = tw;
  resCV.height = th;
  var resCtx = resCV.getContext("2d");
  var imgRes = resCtx.getImageData(0, 0, tw, th);
  var tByteBuffer = imgRes.data;
  // convert float32 array into a UInt8Clamped Array
  var pxIndex = 0; //
  for (
    sIndex = 0, tIndex = 0;
    pxIndex < tw * th;
    sIndex += 3, tIndex += 4, pxIndex++
  ) {
    tByteBuffer[tIndex] = 0 | tBuffer[sIndex];
    tByteBuffer[tIndex + 1] = 0 | tBuffer[sIndex + 1];
    tByteBuffer[tIndex + 2] = 0 | tBuffer[sIndex + 2];
    tByteBuffer[tIndex + 3] = 255;
  }
  // writing result to canvas.
  resCtx.putImageData(imgRes, 0, 0);
  resolve(resCV);
}
function log2(v) {
  // taken from http://graphics.stanford.edu/~seander/bithacks.html
  var b = [0x2, 0xc, 0xf0, 0xff00, 0xffff0000];
  var S = [1, 2, 4, 8, 16];
  var i = 0,
    r = 0;
  for (i = 4; i >= 0; i--) {
    if (v & b[i]) {
      v >>= S[i];
      r |= S[i];
    }
  }
  return r;
}
function normaliseScale(s) {
  if (s > 1) throw "s must be <1";
  s = 0 | (1 / s);
  var l = log2(s);
  var mask = 1 << l;
  var accuracy = 4;
  while (accuracy && l) {
    l--;
    mask |= 1 << l;
    accuracy--;
  }
  return 1 / (s & mask);
}

function YGWebTicket() {
  // useSearchParams and get ticketId and ticketType
  const [searchParams] = useSearchParams();
  const [ticketId, setTicketId] = useState("");
  const [ticketType, setTicketType] = useState("");
  const [imageData, setImageData] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const photoRef = useRef();
  const [label, setLabel] = useState("");
  const [editable, setEditable] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [minute, setMinute] = useState("");
  const [second, setSecond] = useState("");

  useEffect(() => {
    setTicketId(searchParams.get("ticketId").toString());
    setTicketType(searchParams.get("ticketType").toString());

    const getTicketData = async () => {
      const data = {
        ticketId: searchParams.get("ticketId"),
      };

      const config = {
        headers: { Authorization: process.env.REACT_APP_DOBBY_TOKEN },
      };

      axios
        .post(`${process.env.REACT_APP_API_URL}/getTicket`, data, config)
        .then((res) => {
          if (
            searchParams.get("ticketType") === "1" ||
            searchParams.get("ticketType") === "4"
          ) {
            if (res.data.vialLabel.S !== "" && res.data.imageUrl.S !== "") {
              setImageUrl(res.data.imageUrl.S);
              setLabel(res.data.vialLabel.S);
              setEditable(false);
            } else {
              setEditable(true);
            }
          } else if (searchParams.get("ticketType") === "2") {
            if (res.data.vialLabel.S !== "" && res.data.videoUrl.S !== "") {
              setVideoUrl(res.data.videoUrl.S);
              setLabel(res.data.vialLabel.S);
              setMinute(
                Math.floor(parseInt(res.data.videoStartTime.N) / 60).toString()
              );
              setSecond(parseInt(res.data.videoStartTime.N % 60).toString());
              setEditable(false);
            } else {
              setEditable(true);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    getTicketData();
  }, []);

  const removeEmojis = (text) => {
    const emojis =
      /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
    return text.replace(emojis, "");
  };

  const onChangeLabel = (text) => {
    setLabel(removeEmojis(text.target.value));
  };

  const onChangeVideoUrl = (text) => {
    setVideoUrl(text.target.value);
  };

  const onChangeMinute = (text) => {
    setMinute(text.target.value);
  };

  const onChangeSecond = (text) => {
    setSecond(text.target.value);
  };

  const saveData = () => {
    if (ticketType === "1" || ticketType === "4") {
      if (label.length && imageData !== null) {
        const config = {
          headers: {
            Authorization: process.env.REACT_APP_DOBBY_TOKEN,
          },
        };

        const data = {
          ticketId: ticketId,
          vialLabel: label,
          imageUrl: imageData.replace(/^data:image\/[a-z]+;base64,/, ""),
        };

        // console.log(imageData.replace(/^data:image\/[a-z]+;base64,/, ''));

        axios
          .post(`${process.env.REACT_APP_API_URL}/updateTicket`, data, config)
          .then((res) => {
            console.log(res.data);
            if (res.data) {
              setEditable(false);
            }
          })
          .catch((error) => {});
      }
    } else if (ticketType === "2") {
      if (videoUrl.length && minute.length && second.length && label.length) {
        const config = {
          headers: {
            Authorization: process.env.REACT_APP_DOBBY_TOKEN,
          },
        };

        const data = {
          ticketId: ticketId,
          vialLabel: label,
          videoUrl: videoUrl,
          videoStartTime: parseInt(minute) * 60 + parseInt(second),
        };

        axios
          .post(`${process.env.REACT_APP_API_URL}/updateTicket`, data, config)
          .then((res) => {
            console.log(res.data);
            if (res.data) {
              setEditable(false);
            }
          })
          .catch((error) => {});
      }
    }
  };

  return (
    <div className="temporary-qr-container">
      <div className="qr-div">
        <div
          style={{
            fontFamily: "Pretendard-Medium",
            fontSize: "16px",
            marginBottom: "5px",
          }}
        >
          {/* {ticketType === "1" || ticketType === "2"
            ? "Random Diversity: The Movie"
            : ticketType === "4"
            ? "Random Fragrance"
            : "Random Diversity"} */}
        </div>
        {/* <QRCode className="qr-image" value={ticketId} /> */}
        <img
          src={ygLogo}
          alt="YG Logo"
          style={{ maxWidth: "512px", width: "80%", height: "auto" }}
        />
      </div>
      <div className="ticket-content-conatiner">
        {ticketType === "1" || ticketType === "4" ? (
          <div>
            <div
              style={{
                fontFamily: "Pretendard-Medium",
                fontSize: "16px",
                marginBottom: "15px",
                textAlign: "center",
                color: "white",
              }}
            >
              {ticketType === "1" ? (
                <>
                  랜덤 다이버시티에 온 것을 환영합니다. <br />
                  {editable ? "어떤 사진으로 감정을 추출하시나요?" : null}
                </>
              ) : (
                <>
                  랜덤 프래그런스에 온 것을 환영합니다.
                  <br />
                  {editable ? "어떤 사진으로 향기를 추출하시나요?" : null}
                </>
              )}
              <br />
            </div>
            <div className="image-upload-button">
              {imageData || imageUrl !== "" ? (
                <img
                  src={imageData ? imageData : imageUrl}
                  className="imageuploaded"
                  alt="photo"
                />
              ) : (
                <div className="photo-modal">
                  <div
                    id="top-layer"
                    style={{ opacity: 0.5 }}
                    onClick={() => {
                      if (photoRef.current) {
                        downScaleImage(
                          photoRef.current.getImage().toDataURL(),
                          500,
                          0,
                          0
                        ).then((canvas) => {
                          setImageData(canvas.toDataURL());
                        });
                      }
                    }}
                  ></div>
                  <ProfileSelect type={0} ref={photoRef}></ProfileSelect>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div>
            <div
              style={{
                fontFamily: "Pretendard-Medium",
                fontSize: "16px",
                marginBottom: "30px",
                textAlign: "center",
                color: "white",
              }}
            >
              랜덤 다이버시티에 오신 것을 환영합니다.
              <br />
              {editable ? "어떤 영상으로 감정을 추출하시나요?" : null}
            </div>
            <div>
              <div style={{ textAlign: "center" }}>
                <span
                  style={{
                    fontFamily: "Pretendard-Medium",
                    fontSize: "16px",
                    marginBottom: "15px",
                    color: "white",
                  }}
                >
                  유튜브 영상 링크를 입력해주세요
                </span>
                <br />
                <span
                  style={{
                    fontFamily: "Pretendard-light",
                    fontSize: "16px",
                    marginBottom: "15px",
                    color: "white",
                  }}
                >
                  영상 링크는 공유 버튼을 눌러서 복사해주세요
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <input
                  placeholder="영상 링크 주소"
                  type="text"
                  value={videoUrl}
                  onChange={(e) => onChangeVideoUrl(e)}
                  className="video-input"
                  editable={editable.toString()}
                />
              </div>
            </div>
            <div>
              <div
                style={{
                  textAlign: "center",
                  marginTop: "30px",
                }}
              >
                <span
                  style={{
                    fontFamily: "Pretendard-Medium",
                    fontSize: "16px",
                    marginBottom: "15px",
                    color: "white",
                  }}
                >
                  {editable ? "영상 재생 시작 시간을 입력해주세요" : null}
                </span>
                <br />
                <span
                  style={{
                    fontFamily: "Pretendard-light",
                    fontSize: "16px",
                    marginBottom: "15px",
                    color: "white",
                  }}
                >
                  {editable
                    ? "처음부터 재생될 경우 00:00으로 입력해주세요"
                    : null}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div>
                  <input
                    type="text"
                    value={minute}
                    onChange={(e) => onChangeMinute(e)}
                    className="num-input"
                    maxLength={2}
                    editable={editable.toString()}
                  />
                </div>
                <div
                  style={{
                    fontFamily: "Pretendard-Medium",
                    fontSize: "20px",
                    color: "white",
                    margin: "0 10px",
                  }}
                >
                  :
                </div>
                <div>
                  <input
                    type="text"
                    value={second}
                    onChange={(e) => onChangeSecond(e)}
                    className="num-input"
                    maxLength={2}
                    editable={editable.toString()}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {editable ? (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <span
              style={{
                fontFamily: "Pretendard-Medium",
                fontSize: "16px",
                marginBottom: "15px",
                color: "white",
              }}
            >
              {ticketType === "1" || ticketType === "4"
                ? "사진에 어울리는 라벨 이름을 작성해주세요"
                : "포스터 제목을 입력해주세요"}
            </span>
            <br />
            <span
              style={{
                fontFamily: "Pretendard-light",
                fontSize: "16px",
                marginBottom: "15px",
                color: "white",
              }}
            >
              {ticketType === "1" || ticketType === "4"
                ? "라벨은 프린트되어 이모션 백신에 붙여집니다"
                : "포스터 제목은 인쇄될 포스터에 표시됩니다"}
            </span>
          </div>
        ) : null}

        <div>
          <input
            style={{ textAlign: "center" }}
            type="text"
            value={label}
            onChange={(e) => onChangeLabel(e)}
            className="label-input"
            maxLength={10}
            editable={editable.toString()}
          />
        </div>
      </div>
      {editable ? (
        <div style={{ marginTop: "30px", width: "95%" }}>
          <div
            style={{
              color: "black",
              fontFamily: "Pretendard-Medium",
              textAlign: "center",
            }}
          >
            데이터 전송 후에는 수정이 불가능합니다
          </div>
          <div className="save-button" onClick={() => saveData()}>
            저장하기
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default YGWebTicket;
